
import { defineComponent } from "vue";
import Modal from "../modals/Modal.vue";
import Search from "../application/inputs/Search.vue";

export default defineComponent({
  name: "RecommendCourse",
  components: {
    Modal,
    Search,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {};
  },
});
